import { useContext, useState } from "react";

import BundleAlbum from "./BundleAlbum";
import BundleTitlePrice from "./BundleTitlePrice";
import BundleExtraProducts from "./BundleExtraProducts";
import BundleInstantSaving from "./BundleInstantSaving";
import BundleExtraPricesCart from "./BundleExtraPricesCart";
import BundleAddTotalsToCart from "./BundleAddTotalsToCart";
import Accordion from "@/components/product/tabs/Accordion";
import { handleAddItemsToCart } from "@/utils/product/addToCartFunc";
import { useCart } from "@/context/cart";
import CloseIcon from "@/components/icons/CloseIcon";
import { retainKeys } from "@/utils/product";
import { v4 as uuidv4 } from "uuid";
import { ModalContext } from "@/pages/_app";

const BuildBundleModal = ({ bundles, product: parentProduct, setOpen, t, relatedProducts, bundleSKUs, parentQty, setParentQty, selectedProducts, setSelectedProducts }) => {
  const [bundleInView, setBundleInView] = useState(bundles?.at(0));
  const [loading, setLoading] = useState(false);
  const parentInStock =
    parentProduct?.stock?.qty >= 0 || parentProduct?.stock?.is_in_stock == true;
  const { dispatch: dispatchCart } = useCart();
  const context = useContext(ModalContext);

  return (
    <>
      <div className="flex justify-between items-center">
        <h1 className="text-2xl max-sm:text-lg font-bold">
          {t("Buy together and save")}
        </h1>
        <div className="cursor-pointer" onClick={() => {
          setOpen(false)
          setSelectedProducts([])
        }}>
          <CloseIcon className={"size-4"} stroke={1} />
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6 my-4">
        <div className=" col-span-3 max-sm:order-2">
          <BundleAlbum {...{ parentProduct }} />
        </div>
        <div className="max-sm:col-span-7 max-sm:order-1 col-span-4">
          <BundleTitlePrice {...{ parentProduct, parentQty, setParentQty }} />
          <button
            onClick={() =>
              handleAddItemsToCart(bundleSKUs, setLoading, dispatchCart, Object.values(retainKeys(parentProduct?.selectedConfigurations, ['attribute_id', 'option_id'])), context, relatedProducts)
            }
            disabled={!parentInStock}
            className={`flex-1 px-3 py-1 text-[11px] mt-2 hidden max-sm:flex rounded-md ${
              !parentInStock
                ? "bg-gray-200 text-gray-600"
                : "bg-primary text-white"
            } flex justify-center items-center w-full gap-2`}
          >
            {loading && <div className="loader w-6 text-white" />}
            <p>
              {parentInStock
                ? t("Add to cart")
                : t("Parent product is out of stock")}
            </p>
          </button>
        </div>
        <div className="max-sm:hidden col-span-5">
          <BundleAddTotalsToCart
            {...{
              selectedProducts,
              setSelectedProducts,
              parentProduct,
              bundleSKUs,
              bundles,
              parentInStock,
              parentQty,
              setOpen,
              relatedProducts,
              t,
              context,
            }}
          />
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6 max-sm:hidden">
        <div className="max-sm:col-span-full col-span-3">
          <BundleInstantSaving
            {...{ bundles, setBundleInView, bundleInView, t }}
          />
        </div>
        <div className="max-sm:col-span-full col-span-9 border rounded-md px-7 py-4">
          <h5 className="font-bold text-[17px] max-sm:text-sm">
            {bundleInView?.title}
          </h5>
          {/* <h6 className="text-[17px]">Limit 3 items below per bundle </h6> */}
          {bundleInView?.product_links?.map((product) => (
            <div
              key={product?.id + product?.sku}
              className="grid grid-cols-12 mt-4 gap-7 max-sm:mt-8"
            >
              <BundleExtraProducts key={product?.id} {...{ product, t }} />
              <div className="max-sm:col-span-full col-span-6">
                <BundleExtraPricesCart
                  key={product?.id}
                  {...{ product, selectedProducts, setSelectedProducts, t }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="grid-cols-12 gap-6 hidden max-sm:grid">
        {bundles?.map((bundle) => (
          <div key={uuidv4()} className="col-span-12">
            <Accordion
              head={bundle?.title}
              key={uuidv4()}
              body={bundle?.product_links?.map((product) => (
                <div
                  key={uuidv4()}
                  className="grid grid-cols-12 mt-4 gap-7 overflow-visible max-sm:mt-3 max-sm:gap-0"
                >
                  <BundleExtraProducts
                    key={uuidv4()}
                    {...{ product, selectedProducts, setSelectedProducts, t }}
                  />
                  <div className="max-sm:col-span-6 col-span-6">
                    <BundleExtraPricesCart
                      {...{ product, selectedProducts, setSelectedProducts, t }}
                    />
                  </div>
                </div>
              ))}
            />
          </div>
        ))}
        {/* <div className="max-sm:col-span-full col-span-3">
              <BundleInstantSaving
                {...{ bundles, setBundleInView, bundleInView, t }}
              />
            </div> */}
        {/* <div className="max-sm:col-span-full col-span-9 border rounded-md px-7 py-4">
              <h5 className="font-bold text-[17px] max-sm:text-sm">{bundleInView?.title}</h5>
              <h6 className="text-[17px]">Limit 3 items below per bundle </h6>
              {bundleInView?.product_links?.map((product, i) => (
                <div key={i} className="grid grid-cols-12 mt-4 gap-7 max-sm:mt-8">
                  <BundleExtraProducts key={i} {...{ product, t }} />
                  <div className="max-sm:col-span-full col-span-6">
                    <BundleExtraPricesCart
                      {...{ product, selectedProducts, setSelectedProducts, t }}
                    />
                  </div>
                </div>
              ))}
            </div> */}
      </div>
    </>
  );
};

export default BuildBundleModal;
